var socket;
connect();
coupon_pop_event();
function connect() {
		var userName = 'WantDo';
        var clientId = getCookie('w_client_id');
		var opts = {
			query: 'userName=' + userName + '&clientId=' + clientId,
			transports:['websocket','xhr-polling','jsonp-polling']
		};
		socket = io.connect('https://wsdsp.wantdo.com', opts);
		socket.on('connect', function () {
			console.log("socket success....");
		});
		socket.on('message_event', function (data) {
		 console.log("收到消息：" + data);
		opCouponPop(data);
		});
		socket.on('connect_error', function(data){
			console.log(data + ' - connect_error');
		    socket.disconnect();
		});
		socket.on('connect_timeout', function(data){
			console.log(data + ' - connect_timeout');
			socket.disconnect();
		});
		socket.on('error', function(data){
			console.log(data + ' - error');
			socket.disconnect();
		});

		socket.on('disconnect', function () {
			console.log('disconnect...');
		});
	}
//执行左下角coupon自动函数
   function coupon_pop_event() {
	   	var coupon_pop_event = getCookie('coupon_pop_event');
	   	var coupon_data = window.atob(decodeURIComponent(getCookie('coupon_data')));
	   	console.log('coupon_data:' + coupon_data)
	   	if (coupon_data != null && coupon_data != '') {
	   		opGradient(coupon_data);
	   		if (coupon_pop_event != null && coupon_pop_event != '' && coupon_pop_event != '1') {
	   			openPop(coupon_data);
	   		}
	   	}
	   }


	   function opCouponPop(str) {
	   	var data = JSON.parse(str);
	   	var messageType = data.messageType;
	   	console.log('接收类型：' + messageType);
	   	if (messageType != 'DISCOUNT_COUPON') {
	   		return;
	   	}
        var expirationDays = data.expirationDays;
    
         setCookie('coupon_data', window.btoa(decodeURIComponent(str)), expirationDays);
	   	openPop(str);
        opCouponPopEvent(0,"display");
	   	opGradient(str);
	   }

	   function opGradient(str) {
	   	document.getElementById('socket-lower-left').style.display = "block";
	   	document.getElementById('socket-lower-left').addEventListener('click', () => {
	   		openPop(str);
	   	});
	   }
	   function openPop(str) {
	    document.getElementById('coupon-socket').style.display = "block";
	   	var data = JSON.parse(str);
	   	document.getElementById('socket-lower-left').style.display = "block";
	   	document.getElementById('coupon-socket').style.display = "block";
	   	document.getElementById('socket-code1').innerText = data.discountValue.replace("&&","%");
	   	document.getElementById('socket-code2').innerText = data.promotionCode.replace("&&","%");
	   	document.getElementById('socket-time').innerText = data.lifeTime;
        document.getElementById('push-id').innerText = data.pushId;
	   	document.getElementById('socket-code-collection').innerText = data.promptMessage;
        document.getElementById('socket-close').addEventListener('click', closeClick, false);
        document.getElementById('socket-copy').addEventListener('click', copyClick, false);
	   }
 
     function copyClick() {
          opCouponPopEvent(1,'copy');
          copyCode();
          const copya=document.getElementById('socket-copy-a');
    	  copya.innerText = 'Copied!';
    	  copya.style.background = "#44919D";
          document.getElementById('socket-copy').removeEventListener('click', copyClick, false);
        }
  
    function closeClick() {
      document.getElementById('coupon-socket').style.display = "none";
	  opCouponPopEvent(1,'close');
      document.getElementById('socket-close').removeEventListener('click', closeClick, false);
    }

    function copyCode() {
         var copyValue = document.getElementById('socket-code2').innerText;
          //创建一个新组件
          let oInput = document.createElement("input");
          //给新组件赋值
          oInput.value = copyValue;
          //添加新节点到页面body中
          document.body.appendChild(oInput);
          //选择对象
          oInput.select();
          //对选择对象的值进行复制到浏览器中
          document.execCommand("Copy");
          //删除新节点(重置操作)
          document.body.removeChild(oInput);
         console.log('code：'+copyValue);
        }
	   function opCouponPopEvent(flag,eventType) {
	   	//将关闭弹窗和复制优惠码事件放入cookie，每次打开检查，如果是1，则不进行弹出
	   	setCookie('coupon_pop_event', flag, 7);
        push_pop_event(eventType);
	   }
	
     function push_pop_event(eventType) {
        	var pushId =  document.getElementById('push-id').innerText;
            var coupon =  document.getElementById('socket-code2').innerText;
           var pageUrl = escape(window.location.href);
        	var pageTitle = escape(document.title);
             var productId = "";
          if (pageUrl.indexOf('/products/') != -1) {
          	productId = document.getElementById('product-box').getAttribute('product-id');
          }
       var clientIp = getCookie('browserIp');
        var clientId = getCookie('w_client_id');
        	var str = {
                "clientId": clientId,
        		"pushId": pushId,
        		"eventType": eventType,
              "productId": productId,
              "clientIp": escape(clientIp),
                 "pageUrl": pageUrl,
        		"pageTitle": pageTitle,
        		"data": escape(coupon),
        		"random": Math.random().toString(36).slice(-8)
        	};
        	console.log(str);
        	var params = jsonToUrlParam(str);
             var src = "https://dspv4.wantdo.com/dsp/f/tracing/coupon-pop-event.gif?" + params;
        	// console.log("src:" + src)

        	var img = document.createElement("img");
        	img.setAttribute("rel", "nofollow");
        	img.setAttribute('class', 'CToWUd');
        	img.setAttribute('width', '0px');
        	img.setAttribute('height', '0px');
        	img.src = src;
        	document.body.appendChild(img);
        }
	   function setCookie(name, value, days) {
	   	var exp = new Date();
	   	exp.setTime(exp.getTime() + (days * 24 * 60 * 60 * 1000));
	   	document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=/";
	   }

	   function getCookie(cname) {
	   	var name = cname + "=";
	   	var ca = document.cookie.split(';');
	   	for (var i = 0; i < ca.length; i++) {
	   		var c = ca[i].trim();
	   		if (c.indexOf(name) == 0) {
	   			return c.substring(name.length, c.length);
	   		}
	   	}
	   	return "";
	   }
